import { type FC } from 'react';
import { type TestProps, Text, TextCell } from '@direct-frontend/components';

type ProductBackInStockRequestsCellProps = {
    count: number;
    onClick?: VoidFunction;
    className?: string;
} & TestProps;

export const ProductBackInStockRequestsCell: FC<ProductBackInStockRequestsCellProps> = ({
    count,
    onClick,
    className,
    'data-testid': dataTestId,
}) => (
    <TextCell
        data-testid={dataTestId}
        className={className}
        onClick={onClick}
        align="right"
        title={(textProps) => <Text {...textProps}>{String(count)}</Text>}
    />
);
